import HeaderBasic from 'components/Headers/Basic';
import {FC} from 'react';
import {Size} from 'types';

export interface Props {
    className?: string;
    dropdownLocaleSize?: Size;
    showLanguage?: boolean;
    showSignIn?: boolean;
}

const Header: FC<Props> = ({
    className = 'pb-2',
    dropdownLocaleSize = 'xs',
    showLanguage = true,
    showSignIn = false,
}) => (
    <HeaderBasic
        {...{className, dropdownLocaleSize, showLanguage, showSignIn}}
    />
);

export default Header;
